module.exports = __webpack_public_path__ + "img/cart_.140ec670.jpg";